import { getSiteURL } from "../helper/libs/get-site-url";

// API_BASE_URL is defined once in utils/apiConfig.js — re-exported here
// so existing `import { API_BASE_URL } from "utils/config"` call sites
// keep working unchanged.
import { API_BASE_URL } from "./apiConfig";
export { API_BASE_URL };

// Backend API Endpoints
export const API_ENDPOINTS = {
  LOGIN: `${API_BASE_URL}/api/auth/login`,
  USERLOGIN: `${API_BASE_URL}/api/auth/userlogin`,
  DASHBOARD: `${API_BASE_URL}/api/dashboard`,
  SUBSCRIPTIONS: `${API_BASE_URL}/api/subscriptions`,
  SUBSCRIPTION_PURCHASE: `${API_BASE_URL}/api/subscriptions/purchase`,
  FREE_TRIAL_INFO: `${API_BASE_URL}/api/user/trial-info`,
  PROFILE: `${API_BASE_URL}/api/user/profile/:id`,
  ACTIVE_SUBSCRIPTION_STATUS: `${API_BASE_URL}/api/subscriptions/active-subscription-status`,
};

// Site config
export const config = {
  site: {
    name: "Devias Kit",
    description: "",
    themeColor: "#090a0b",
    url: getSiteURL(),
  },
  logLevel: process.env.REACT_APP_LOG_LEVEL || "ALL",
};

// Routes are NOT defined here: sidebar-module routes live on each Module in the database (route_path + page_key),
// every other route (login, landing, Settings sub-paths …) in the AppRoute table (GET /api/app-routes). App.jsx builds
// the router from them; utils/pageRegistry.js links a page key to its component and utils/appRoutes.js answers
// routeOf("<name or page key>") for code that needs a URL.

export default config;
